<template>
  <div id="card-checkbox">
    <div class="panel panel-default contact-card card-view">
      <div class="bg-white">
        <div class="row card-row">
          <div class="col-md-2">
            <div class="user-img-wrap">
              <i class="circle">
                <img class="icon" :src="`${imagePath}`">
              </i>
            </div>
          </div>
          <div class="col-md-9 without-left-padding">
            <div class>
              <div class="user-detail-wrap">
                <span>{{$t('app.inspections.date_inspection')}}</span>
                <div v-for="(option,index) in list" :key="index" class="checkbox">
                  <base-checkbox
                    :id="`checkbox-${index}`"
                    :labelValue="option"
                    labelClassNames="small-label"
                    :inputDisabled="inputDisabled"
                    @valueChanged="valueChanged($event, index)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="pull-right"></div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCheckbox from '@/components/shared/inputs/BaseCheckbox';

export default {
  name: 'BaseInput',
  components: {
    'base-checkbox': BaseCheckbox,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: [String, Number],
      required: false,
    },
    labelClassNames: {
      type: String,
      default: '',
    },
    labelValue: {
      type: String,
      default: '',
    },
    imagePath: {
      type: String,
      default: 'static/avatar.png',
    },
    inputDisabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      values: [],
    };
  },
  created() {
    this.values.length = this.list.length;
    this.values.fill(false);
  },
  methods: {
    valueChanged(event, index) {
      this.values[index] = event;
      this.$emit('valueChanged', this.values);
    },
  },
};
</script>

<style lang="scss" scoped>
.small-label {
  font-size: 10px;
}

.panel-heading {
  max-height: 120px;
}

.card-row {
  min-height: 150px;
}

.circle {
    border-radius: 50%;
    border: 1px solid var(--main-color);
    text-align: center;
    display: inline-block;
    padding: 14px;
    height: 50px !important;
    width: 50px !important;
  }

  .icon {
    height: 20px !important;
    width: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/CardCheckbox.vue